import { fetchData } from "@client";

export async function getTemplatePreviewQuery(id) {
  const res = await fetchData(`/template/${id}`);
  if(!res.results?.length)
    throw { code: "template_broken" }
  return {
    structure: res.results[0].structure,
    comments: res.results[0].comments,
    versions: res.results.map(r => ({
      key: r.key,
      name: r.name,
      order: r.order,
      visible: 1
    }))
  };
}
